import { GameId, SupportedLanguage } from '@common'

import { useLocale } from '@/features/locale/useLocale'

import BrawlStarsBg from 'assets/images/brawlstars/background.png'
import BrawlStarsBadgeOutline from 'assets/images/brawlstars/badge-outline.svg'
import BrawlStarsBadge from 'assets/images/brawlstars/badge.png'
import BrawlStarsGameBadge from 'assets/images/brawlstars/game-badge.png'
import BrawlStarsHeroDesktop_JA from 'assets/images/brawlstars/hero-desktop-ja.png'
import BrawlStarsHeroDesktop from 'assets/images/brawlstars/hero-desktop.png'
import BrawlStarsHeroMobile_JA from 'assets/images/brawlstars/hero-mobile-ja.png'
import BrawlStarsHeroMobile from 'assets/images/brawlstars/hero-mobile.png'
import BrawlStarsLogo_JA from 'assets/images/brawlstars/logo-ja.png'
import BrawlStarsLogo from 'assets/images/brawlstars/logo.png'
import BrawlStarsPass from 'assets/images/brawlstars/pass.png'
import ClashOfClansBg from 'assets/images/clashofclans/background.png'
import ClashOfClansBadgeOutline from 'assets/images/clashofclans/badge-outline.svg'
import ClashOfClansBadge from 'assets/images/clashofclans/badge.png'
import ClashOfClansGameBadge from 'assets/images/clashofclans/game-badge.png'
import ClashOfClansHeroDesktop_JA from 'assets/images/clashofclans/hero-desktop-ja.png'
import ClashOfClansHeroDesktop from 'assets/images/clashofclans/hero-desktop.png'
import ClashOfClansHeroMobile_JA from 'assets/images/clashofclans/hero-mobile-ja.png'
import ClashOfClansHeroMobile from 'assets/images/clashofclans/hero-mobile.png'
import ClashOfClansLogo_JA from 'assets/images/clashofclans/logo-ja.png'
import ClashOfClansLogo from 'assets/images/clashofclans/logo.png'
import ClashOfClansPass from 'assets/images/clashofclans/pass.png'
import ClashRoyaleBg from 'assets/images/clashroyale/background.png'
import ClashRoyaleBadgeOutline from 'assets/images/clashroyale/badge-outline.svg'
import ClashRoyaleBadge from 'assets/images/clashroyale/badge.png'
import ClashRoyaleGameBadge from 'assets/images/clashroyale/game-badge.png'
import ClashRoyaleHeroDesktopJA from 'assets/images/clashroyale/hero-desktop-ja.png'
import ClashRoyaleHeroDesktop from 'assets/images/clashroyale/hero-desktop.png'
import ClashRoyaleHeroMobileJA from 'assets/images/clashroyale/hero-mobile-ja.png'
import ClashRoyaleHeroMobile from 'assets/images/clashroyale/hero-mobile.png'
import ClashRoyaleLogo_JA from 'assets/images/clashroyale/logo-ja.png'
import ClashRoyaleLogo from 'assets/images/clashroyale/logo.png'
import ClashRoyalePassPremium from 'assets/images/clashroyale/pass-prem.png'
import ClashRoyalePass from 'assets/images/clashroyale/pass.png'
import HayDayBg from 'assets/images/hayday/background.png'
import HayDayBadge_JA from 'assets/images/hayday/badge-ja.png'
import HayDayBadgeOutline from 'assets/images/hayday/badge-outline.svg'
import HayDayBadge from 'assets/images/hayday/badge.png'
import HayDayGameBadge from 'assets/images/hayday/game-badge.png'
import HayDayHeroDesktop_JA from 'assets/images/hayday/hero-desktop-ja.png'
import HayDayHeroDesktop from 'assets/images/hayday/hero-desktop.png'
import HayDayHeroMobile_JA from 'assets/images/hayday/hero-mobile-ja.png'
import HayDayHeroMobile from 'assets/images/hayday/hero-mobile.png'
import HayDayLogo_JA from 'assets/images/hayday/logo-ja.png'
import HayDayLogo from 'assets/images/hayday/logo.png'
import HayDayPass from 'assets/images/hayday/pass.png'

type LocalizedVariants = Partial<Record<SupportedLanguage, typeof HayDayBg>> & Record<'default', typeof HayDayBg>
type Images = Record<GameId, ImageVariants>

interface ImageVariants {
  passProductImageDefault: LocalizedVariants
  passProductImageBasic: LocalizedVariants
  passProductImagePremium: LocalizedVariants
  logo: LocalizedVariants
  badge: LocalizedVariants
  gameBadge: LocalizedVariants
  badgeOutline: LocalizedVariants
  heroMobile: LocalizedVariants
  heroDesktop: LocalizedVariants
  background: LocalizedVariants
}

const images: Images = {
  clashofclans: {
    passProductImageDefault: {
      default: ClashOfClansPass,
    },
    passProductImageBasic: {
      default: ClashOfClansPass,
    },
    passProductImagePremium: {
      default: ClashOfClansPass,
    },
    logo: {
      ja: ClashOfClansLogo_JA,
      default: ClashOfClansLogo,
    },
    badge: {
      default: ClashOfClansBadge,
    },
    gameBadge: {
      default: ClashOfClansGameBadge,
    },
    badgeOutline: {
      default: ClashOfClansBadgeOutline,
    },
    heroMobile: {
      ja: ClashOfClansHeroMobile_JA,
      default: ClashOfClansHeroMobile,
    },
    heroDesktop: {
      ja: ClashOfClansHeroDesktop_JA,
      default: ClashOfClansHeroDesktop,
    },
    background: {
      default: ClashOfClansBg,
    },
  },
  hayday: {
    passProductImageDefault: {
      default: HayDayPass,
    },
    passProductImageBasic: {
      default: HayDayPass,
    },
    passProductImagePremium: {
      default: HayDayPass,
    },
    logo: {
      default: HayDayLogo,
      ja: HayDayLogo_JA,
    },
    badge: {
      default: HayDayBadge,
      ja: HayDayBadge_JA,
    },
    gameBadge: {
      default: HayDayGameBadge,
    },
    badgeOutline: {
      default: HayDayBadgeOutline,
    },
    heroMobile: {
      default: HayDayHeroMobile,
      ja: HayDayHeroMobile_JA,
    },
    heroDesktop: {
      default: HayDayHeroDesktop,
      ja: HayDayHeroDesktop_JA,
    },
    background: {
      default: HayDayBg,
    },
  },
  brawlstars: {
    passProductImageDefault: {
      default: BrawlStarsPass,
    },
    passProductImageBasic: {
      default: BrawlStarsPass,
    },
    passProductImagePremium: {
      default: BrawlStarsPass,
    },
    logo: {
      default: BrawlStarsLogo,
      ja: BrawlStarsLogo_JA,
    },
    badge: {
      default: BrawlStarsBadge,
    },
    gameBadge: {
      default: BrawlStarsGameBadge,
    },
    badgeOutline: {
      default: BrawlStarsBadgeOutline,
    },
    heroMobile: {
      default: BrawlStarsHeroMobile,
      ja: BrawlStarsHeroMobile_JA,
    },
    heroDesktop: {
      default: BrawlStarsHeroDesktop,
      ja: BrawlStarsHeroDesktop_JA,
    },
    background: {
      default: BrawlStarsBg,
    },
  },
  clashroyale: {
    passProductImageDefault: {
      default: ClashRoyalePass,
    },
    passProductImageBasic: {
      default: ClashRoyalePass,
    },
    passProductImagePremium: {
      default: ClashRoyalePassPremium,
    },
    logo: {
      default: ClashRoyaleLogo,
      ja: ClashRoyaleLogo_JA,
    },
    badge: {
      default: ClashRoyaleBadge,
    },
    gameBadge: {
      default: ClashRoyaleGameBadge,
    },
    badgeOutline: {
      default: ClashRoyaleBadgeOutline,
    },
    heroMobile: {
      default: ClashRoyaleHeroMobile,
      ja: ClashRoyaleHeroMobileJA,
    },
    heroDesktop: {
      default: ClashRoyaleHeroDesktop,
      ja: ClashRoyaleHeroDesktopJA,
    },
    background: {
      default: ClashRoyaleBg,
    },
  },
}

const getGameImage = (locale: SupportedLanguage, game: GameId) => (image: keyof ImageVariants) =>
  images[game][image][locale] ?? images[game][image]['default']

export const useGameImages = (game: GameId) => {
  const locale = useLocale()

  return { gameImage: getGameImage(locale, game) }
}
